<div class="h-100 d-flex flex-column posRelative" id="container">
	<!--			APP VIEWER OWN COMPONENT-->
	@if (showHeader()) {
		<div class="row header" style="margin-right: 0px">
			<div class="col-12" style="padding-left: 0; padding-right: 0">
				<div class="tempFlexContainer">
					<div class="title">
						<h1 class="mat-headline-4" id="scheduleHeader">
							{{ T.SHARED_EVENT_CALENDER_SCHEDULE | translate }}
						</h1>
					</div>
					<div class="toggler">
						<sim-segmented-button #calViewToggler>
							<sim-button-segment
								(onClick)="setCalendarView()"
								[icon]="{fontSet: 'fas', fontIcon: 'fa-calendar'}"
								[matTooltip]="T.SHARED_EVENT_CALENDAR_CALENDAR_VIEW | translate"
								[matTooltipClass]="'accent'"
							/>
							<sim-button-segment
								(onClick)="setEventListView()"
								[icon]="{fontSet: 'fas', fontIcon: 'fa-list'}"
								[matTooltip]="T.SHARED_EVENT_CALENDAR_LIST_VIEW | translate"
								[matTooltipClass]="'accent'"
							/>
						</sim-segmented-button>
					</div>
				</div>
			</div>
		</div>
	}

	@if (!showHeader()) {
		<div class="toggleWithoutHeader" [class.withinEventManger]="showEventsForEventManager()">
			<sim-segmented-button #calViewToggler>
				<sim-button-segment
					(onClick)="setCalendarView()"
					[icon]="{fontSet: 'fas', fontIcon: 'fa-calendar'}"
					[matTooltip]="T.SHARED_EVENT_CALENDAR_CALENDAR_VIEW | translate"
					[matTooltipClass]="'accent'"
				/>
				<sim-button-segment
					(onClick)="setEventListView()"
					[icon]="{fontSet: 'fas', fontIcon: 'fa-list'}"
					[matTooltip]="T.SHARED_EVENT_CALENDAR_LIST_VIEW | translate"
					[matTooltipClass]="'accent'"
				/>
			</sim-segmented-button>
		</div>
	}

	<div class="calListHolder">
		@if (isCalView) {
			<div #cal class="calHolder">
				<sim-component-loading-container
					[loadingMessage]="T.CALENDAR_LOADING_EVENTS | translate"
					loadingIcon="fad fa-calendar-alt"
					[isLoading]="loadingListedEvents"
					[showBackDrop]="true"
					[backdropVariantTwo]="true"
				/>
				<div class="calendarControls" [class.withinEventManger]="showEventsForEventManager()" [@zoomInOnEnter]>
					<div class="monthSelector">
						{{
							getCurrentCalendarDate()
								? getTranslationOfCalendarMonth(getCurrentCalendarDate()?.getMonth()) +
									", " +
									getCurrentCalendarDate().getFullYear()
								: "..."
						}}
					</div>
					<div class="monthPager">
						<button
							mat-icon-button
							color="accent"
							[matTooltip]="T.CALENDAR_CONTROLS_PREV_MONTH | translate"
							matTooltipClass="accent"
							(click)="changeMonth(-1)"
						>
							<mat-icon fontSet="fad" fontIcon="fa-chevron-left" />
						</button>
						<button color="accent" mat-button (click)="today()">
							{{ T.CALENDAR_CONTROLS_TODAY | translate }}
						</button>
						<button
							mat-icon-button
							color="accent"
							[matTooltip]="T.CALENDAR_CONTROLS_NEXT_MONTH | translate"
							matTooltipClass="accent"
							(click)="changeMonth(1)"
						>
							<mat-icon fontSet="fad" fontIcon="fa-chevron-right" />
						</button>
					</div>
				</div>
				<div class="calendarComponent">
					<full-calendar
						id="fullCalendar"
						[class.loadingEventsForCalendar]="loadingListedEvents"
						[@slideInRightOnEnter]
						style="width: 100%; height: 100%"
						[options]="calendarOptions"
						#calendar
					/>
				</div>
			</div>
		}

		@if (!isCalView) {
			<div #app class="appView" id="appView">
				<sim-event-selection
					[isArchive]="false"
					[showBackButton]="true"
					[eventSelectionOnly]="true"
					[showJoinStartActions]="!showEventsForEventManager()"
					[showSelectAllButton]="showSelectAll()"
					(onEventSelected)="eventFromEventSelectionSelected($event)"
					[forceHideRecordingToggle]="true"
					[recordingSelectable]="false"
					[eventActions]="eventActions()"
					[initialFilterOptions]="filterOptions"
					[selectEventString]="T.SHARED_EVENT_CALENDER_OPEN_DASHBOARD | translate"
					[showAllEvents]="true"
					[eventFetchingEndpoint]="showEventsForEventManager() ? 'eventsForEventManager' : 'eventsForRecordingArchive'"
					(onBackClicked)="backButtonFromEventSelectionClicked()"
				/>
			</div>
		}
	</div>
</div>
